/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Dashboard page (/me/home) client-side scripts
namespace('Slzr.Page.Dashboard', function(exports, top) {
  let jQuery;
  const $ = (jQuery = Slzr.jQuery);

  return Slzr.jQuery(function($) {
    if (Slzr.Meta.page !== 'dashboard') { return; }

    // After deletion, accept, or ignore, remove the item from the page
    return $('[data-request="list"]').on('ajax:success.slzr', '[data-action="remove-request"], [data-action="accept-request"], [data-action="ignore-request"]',
      function(evt, data, status, xhr) {
        const request_element = $(this).closest('[data-request="request"]');

        return request_element.remove();
    });
  });
});